module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/facebook-76f728c0bafe653703488eaea701acfb.svg&quot;;"